var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogSingleBetslip.active
    ? _c(
        "div",
        {
          staticClass: "FastBetSlip",
          class: { betslip_layout_2: _vm.betslipLayout2 },
          attrs: { id: "singleBetSlip" }
        },
        [
          _vm._l(_vm.betslipSelectionIds, function(id) {
            return _c("selection-regular", {
              key: id,
              attrs: {
                id: id,
                currentBetSlipState: _vm.currentBetSlipState,
                tab: _vm.tab,
                allowedBetTypesAndReturns: _vm.allowedBetTypesAndReturn,
                parlayStake: 1,
                betsNo: _vm.betsNo,
                allowedMultiSingles: _vm.allowedMultiSingles,
                isFastBet: true
              }
            })
          }),
          _vm._v(" "),
          _c("bet-slip-msgs", {
            staticClass: "BetSlipMsgs",
            attrs: {
              tab: _vm.tab,
              currentBetSlipState: _vm.currentBetSlipState,
              isLoggedIn: _vm.isLoggedIn,
              betsNo: _vm.betsNo,
              betPlacementResult: _vm.betPlacementResult,
              betSlipStatus: _vm.betSlipStatus,
              inRefferal: _vm.inRefferal,
              inRunningDelay: _vm.inRunningDelay,
              gracePeriod: _vm.gracePeriod,
              isFastBet: true,
              promotionsData: _vm.promotionsData,
              state: _vm.state
            }
          }),
          _vm._v(" "),
          _c("bet-slip-btns", {
            staticClass: "BetSlipBtns",
            attrs: {
              tab: _vm.tab,
              currentBetSlipState: _vm.currentBetSlipState,
              isLoggedIn: _vm.isLoggedIn,
              betsNo: _vm.betsNo,
              betSlipTotals: _vm.betSlipTotals,
              gettingABTnR: _vm.gettingABTnR,
              betPlacementResult: _vm.betPlacementResult,
              betSlipStatus: _vm.betSlipStatus,
              inRefferal: _vm.inRefferal,
              betSlipChangeNo: _vm.betSlipChangeNo,
              isFastBet: true,
              dialogSingleBetslip: _vm.dialogSingleBetslip,
              isGeoLocationEnabled: _vm.isGeoLocationEnabled,
              promotionsData: _vm.promotionsData,
              mobileBigAndBelow: _vm.mobileBigAndBelow
            },
            on: { setTabFromBetSlip: _vm.setTabFromBetSlip }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showAll,
                  expression: "showAll"
                }
              ],
              staticClass: "preferenceSwitch"
            },
            [
              _c("preference-switch", {
                attrs: {
                  id: "rememberSingleBetSlipStake",
                  currentBetSlipState: _vm.currentBetSlipState,
                  doNotConfirm: true
                }
              })
            ],
            1
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e9b49bda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9b49bda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/fastBetSlip.vue
// module id = null
// module chunks = 